import { memo } from 'react';

import useTranslation from '@Queries/useTranslation';
import Tariff from './elements/Tariff';
import styles from './Tariffs.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { TariffData } from '@Pages/PageExpressDesign/type';

interface TariffsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  tariffs: TariffData[];
  onScrollToBlock?: (e: MouseEvent, anchorName: string, tariffId?: string) => void;
}

const Tariffs: FC<TariffsProps> = (props) => {
  const { tariffs, onScrollToBlock, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps}>
      <div className={styles.title}>{t('cost-of-services')}</div>
      <div className={styles.text}>{t('tariffs-your-need')}</div>
      <div className={styles.tariffs}>
        {tariffs.map((tariff) => {
          return <Tariff key={tariff.id} tariff={tariff} onScrollToBlock={onScrollToBlock} />;
        })}
      </div>
    </div>
  );
};

export default memo(Tariffs);
